export const excludeList = new Set([
    "Example",
    "DevJustin",
    "devScott",
    "NexTech Sales",
    "NexTech AR Solutions Corp",
    "Developer Portal",
    "devContent",
    "devIan"
])